<script>
    import Route, {router} from "../lib/Router/Router.svelte";
    import A from "../lib/Router/A.svelte";
    import {sort, copyObjectData} from "../lib/lib";
    import R, {LOADER} from "../lib/requests";
    import Alert from "../stores/alerts";
    import Notifier from "../stores/notifier";
    import PageHeader from "../components/PageHeader.svelte";
    import TableHeader from "../components/TableHeader.svelte";
    import HotelEdit from "./HotelEdit.svelte";
    import ColoredNameControl from "../components/controls/ColoredNameControl.svelte";
    import AppIcon from "../components/icons/AppIcon.svelte";


    let hotels = null;
    let selectedId = 0;

    const pageHeaderControls = [
        {id: 'create', name: 'CREATE HOTEL', link: '/app/hotel/create', class: 'hidden-xs'},
        {id: 'create', name: '', icon: 'plus-circle', link: '/app/hotel/create', class: 'hidden-xl hidden-lg hidden-md hidden-sm'},
        {key: 'reload', name: '', icon: 'refresh'}
    ];

    const tableColumns = [
        {key: 'name', title: 'NAME', sortable: true, sort_way: 'ASC'},
        {key: 'account', title: 'ACCOUNT', sortable: true, class: 'hidden-sm hidden-xs'},
        {key: 'departments', title: 'DEPARTMENTS', sortable: true, class: 'hidden-sm hidden-xs'},
        {key: '', title: ''},
    ];

    const load = () => {
        const onSuccess = result => {
            hotels = result;
        }

        const onFailure = err => {
        };

        R.handle(R.hotel.index, [], onSuccess, onFailure, LOADER.PAGE);
    }

    const onColumnSort = ({detail: column}) => {
        hotels = sort(hotels, column.key, column.sort_way === 'ASC');
    }

    const updateRecord = (hotel) => {
        let item = hotels.find(x => x.id === hotel.id);
        if (!item) {
            hotels = [hotel, ...hotels];
        } else {
            copyObjectData(hotel, item, true);
            item.account = hotel.account;
            hotels = hotels;
        }
    }

    const onEdit = (hotel) => {
        selectedId = hotel.id;
        router.go(`/app/hotel/${selectedId}`)();
    }

    const onDelete = (hotel) => {
        Alert.delete("Delete hotel", `This will permanently delete hotel "${hotel.name}" and the associated location.\nAre you sure?`, () => deleteHotel(hotel.id));
    }

    const deleteHotel = (id) => {
        const onSuccess = result => {
            hotels = hotels.filter(x => x.id !== result);
            Notifier.showMessage("Hotel deleted");
        }

        const onFailure = err => {
            if (err.code === 'object_related') {
                Alert.warning("Delete hotel", `Hotel is related to ${err.params.transfers} transfers!\nYou can not delete this hotel.`);
            }
        };

        R.handle(R.hotel.delete, id, onSuccess, onFailure, LOADER.POPUP);
    }

    load();
</script>

<Route exact>
    <PageHeader title="Hotels" controls={ pageHeaderControls } on:reload={ load }/>

    {#if hotels}
        <div class="panel mb-4">
            <div class="panel-body">
                {#if hotels.length}
                    <table class="table table-list table-list-border">
                        <TableHeader {tableColumns} on:sort={ onColumnSort }/>
                        <tbody>
                        {#each hotels as hotel}
                            <tr class="row-hover" class:row-selected="{ selectedId === hotel.id }">
                                <td>
                                    <span class="is-link" class:not-active={ hotel.is_active < 1}
                                          on:click="{ () => onEdit(hotel) }">
                                            { hotel.name }
                                    </span>
                                </td>
                                <td class="hidden-sm hidden-xs">
                                    {#if hotel.account}
                                        <div>
                                            <A href="/app/account/{ hotel.account.id }"
                                               class="text-gray is-link">
                                                <span class:not-active={ hotel.account.is_active < 1 }>
                                                    { hotel.account.name }
                                                </span>
                                            </A>
                                        </div>
                                    {/if}
                                </td>
                                <td class="hidden-sm hidden-xs">
                                    {#each hotel.departments as department}
                                        <div>
                                            <A href="/app/department/{ department.id }">
                                                <ColoredNameControl name="{ department.name }"
                                                                    color="{ department.color }"
                                                                    colorName isLink
                                                                    isActive="{ department.is_active  }"/>
                                            </A>
                                        </div>
                                    {/each}
                                </td>
                                <td class="button-column pointer" title="delete hotel" on:click="{ () => onDelete(hotel) }">
                                    <AppIcon icon="trash" size="16"/>
                                </td>
                            </tr>
                        {/each}
                        </tbody>
                    </table>
                {:else}
                    <div class="panel-pad">
                        <p>
                            There are no hotels
                        </p>
                        <A href="/app/hotel/create" class="btn btn-primary">CREATE HOTEL</A>
                    </div>
                {/if}
            </div>
        </div>
    {/if}
</Route>
<Route match="*" let:router>
    <HotelEdit updateCallback="{ updateRecord }" hotelId="{ router.star }"/>
</Route>